import { Api } from "api";

type AuthPayload = {
  phone: string;
  password: string;
};

type TokenHash = {
  hash: string;
};

export type AuthResponse = {
  access: TokenHash;
  refresh: TokenHash;
};

export const authorize = async (payload: AuthPayload): Promise<AuthResponse> => {
  const res = await Api.post("/auth/v1/login", payload);
  localStorage.setItem("accessToken", res.data.access.hash);
  localStorage.setItem("refreshToken", res.data.refresh.hash);
  //Api.defaults.headers.common.Authorization = `Bearer ${res.data.access.accessToken}`;
  return res.data;
};

export const refreshToken = async (): Promise<AuthResponse> => {
  const refresh = localStorage.getItem("refreshToken");
  const res = await Api.post("/auth/v1/refresh", { token: refresh });
  return res.data;
};
